import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";

// レイヤーボタン。オンオフ状態を持つ。
const layerButtons = [
    { key: 'floodInundationHazardMapLayer', title: '洪水害ハザードマップ' },
    { key: 'sedimentDisasterHazardMapLayer', title: '土砂災害ハザードマップ' },
    { key: 'floodLayer', title: 'キキクル 洪水害' },
    { key: 'landslideLayer', title: 'キキクル 土砂災害' },
    { key: 'inundationLayer', title: 'キキクル 浸水害' },
    { key: 'highResolutionNowcastLayer', title: '高解像度降水ナウキャスト' },
]

// ズームボタン
const zoomButtons = [
    { key: 'in', title: 'ズームイン' },
    { key: 'out', title: 'ズームアウト' },
]

// ムーブボタン。オンオフ状態を持つ。
const moveButtons = [
    { key: 'resetOrRegist', title: { on: 'リセット', off: '登録' } },
    { key: 'jump', title: { on: 'ジャンプ', off: '　' } },
]

const layerButton = {
    backgroundSize: 'contain',
    height: 64,
    width: 64,
    borderRadius: 32,
    boxShadow: '0 0 1em rgb(0 0 0 / 20%)',
};

const zoomButton = {
    backgroundSize: 'contain',
    height: 50,
    width: 50,
    minWidth: 50,
    borderRadius: 25,
    boxShadow: '0 0 1em rgb(0 0 0 / 20%)',
};

const moveButton = {
    backgroundSize: 'contain',
    height: 50,
    width: 50,
    minWidth: 50,
    borderRadius: 25,
    boxShadow: '0 0 1em rgb(0 0 0 / 20%)',
};

const useStyles = makeStyles(() => ({
    root: {
    },
    layerButtonTitle: {
        width: 64,
        font: "8px/12px 'Hiragino Kaku Gothic ProN', 'YuGothic', 'Meiryo', 'sans-serif'",
        color: '#fff',
        fontWeight: '300',
        textAlign: 'center',
    },

    layerButtonBox: {
        height: 100,
        width: 64,
    },
    layerButtonFrame: {
        overflow: 'overlay',
        position: 'absolute',
        top: 80,
        right: 10,
    },
    layerButton0on: { ...layerButton, backgroundImage: `url('./images/icon01_on.svg')`, },
    layerButton1on: { ...layerButton, backgroundImage: `url('./images/icon02_on.svg')`, },
    layerButton2on: { ...layerButton, backgroundImage: `url('./images/icon03_on.svg')`, },
    layerButton3on: { ...layerButton, backgroundImage: `url('./images/icon04_on.svg')`, },
    layerButton4on: { ...layerButton, backgroundImage: `url('./images/icon06_on.svg')`, },
    layerButton5on: { ...layerButton, backgroundImage: `url('./images/icon07_on.svg')`, },
    layerButton0off: { ...layerButton, backgroundImage: `url('./images/icon01_off.svg')`, },
    layerButton1off: { ...layerButton, backgroundImage: `url('./images/icon02_off.svg')`, },
    layerButton2off: { ...layerButton, backgroundImage: `url('./images/icon03_off.svg')`, },
    layerButton3off: { ...layerButton, backgroundImage: `url('./images/icon04_off.svg')`, },
    layerButton4off: { ...layerButton, backgroundImage: `url('./images/icon06_off.svg')`, },
    layerButton5off: { ...layerButton, backgroundImage: `url('./images/icon07_off.svg')`, },


    zoomButtonTitle: {
        width: 50,
        font: "10px/14px 'Hiragino Kaku Gothic ProN', 'YuGothic', 'Meiryo', 'sans-serif'",
        color: '#fff',
        fontWeight: '300',
        textAlign: 'center',
    },
    zoomButtonFrame: {
        overflow: 'overlay',
        position: 'absolute',
        bottom: 200,
        right: 10,
    },
    zoomButtonBox: {
        height: 80,
        width: 50,
    },
    zoomButton0on: { ...zoomButton, backgroundImage: `url('./images/zoom-in.svg')`, },
    zoomButton1on: { ...zoomButton, backgroundImage: `url('./images/zoom-out.svg')`, },

    moveButtonTitle: {
        width: 50,
        font: "10px/14px 'Hiragino Kaku Gothic ProN', 'YuGothic', 'Meiryo', 'sans-serif'",
        color: '#fff',
        fontWeight: '300',
        textAlign: 'center',
    },
    moveButtonFrame: {
        overflow: 'overlay',
        position: 'absolute',
        bottom: 20,
        right: 10,
    },
    moveButtonBox: {
        height: 80,
        width: 50,
    },
    moveButton0on: { ...moveButton, backgroundImage: `url('./images/reset.svg')` },
    moveButton1on: { ...moveButton, backgroundImage: `url('./images/jump.svg')` },
    moveButton0off: { ...moveButton, backgroundImage: `url('./images/add.svg')` },
    moveButton1off: { ...moveButton, backgroundImage: `` },
}));

export function ShortcutButton(props) {
    const { handlers, buttonState } = props;

    const classes = useStyles();

    const layerButtonOnSyles = [
        classes.layerButton4on,
        classes.layerButton5on,
        classes.layerButton2on,
        classes.layerButton0on,
        classes.layerButton1on,
        classes.layerButton3on,
    ];

    const layerButtonOffSyles = [
        classes.layerButton4off,
        classes.layerButton5off,
        classes.layerButton2off,
        classes.layerButton0off,
        classes.layerButton1off,
        classes.layerButton3off,
    ];

    const zoomButtonSyles = [
        classes.zoomButton0on,
        classes.zoomButton1on,
    ];

    const moveButtonOnSyles = [
        classes.moveButton0on,
        classes.moveButton1on,
    ];

    const moveButtonOffSyles = [
        classes.moveButton0off,
        classes.moveButton1off,
    ];

    return (
        <Box className={classes.root}>
            <Box className={classes.layerButtonFrame} >
                {layerButtons.map((x, i) => (
                    <Box key={x.key} className={classes.layerButtonBox}>
                        <Button
                            onClick={e => handlers.onClickLayer(x.key)}
                            color="primary"
                            className={`${buttonState.layers[x.key] ? layerButtonOnSyles[i] : layerButtonOffSyles[i]}`} />
                        <Box className={classes.layerButtonTitle} >
                            {x.title}
                        </Box>
                    </Box>
                ))}
            </Box>

            <Box className={classes.zoomButtonFrame} >
                {zoomButtons.map((x, i) => (
                    <Box key={x.key} className={classes.zoomButtonBox}>
                        <Button
                            onClick={e => handlers.onClickZoom(x.key)}
                            color="primary"
                            className={`${zoomButtonSyles[i]}`} />
                        <Box className={classes.zoomButtonTitle} >
                            {x.title}
                        </Box>
                    </Box>
                ))}
            </Box>

            <Box className={classes.moveButtonFrame} >
                {moveButtons.map((x, i) => (
                    <Box key={x.key} className={classes.moveButtonBox}>
                        <Button
                            onClick={e => handlers.onClickMove(x.key)}
                            color="primary"
                            className={`${buttonState.move ? moveButtonOnSyles[i] : moveButtonOffSyles[i]}`} />
                        <Box className={classes.moveButtonTitle} >
                            {`${buttonState.move ? x.title.on : x.title.off}`}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default ShortcutButton;